import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./OfferCustomerPotenitalFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import OfferCustomerPotenitalFormStepOne from "./OfferCustomerPotenitalFormSteps/OfferCustomerPotenitalFormStepOne";
import OfferCustomerPotenitalFormStepTwo from "./OfferCustomerPotenitalFormSteps/OfferCustomerPotenitalFormStepTwo";

const OfferCustomerPotenitalForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        offerType: _initialValues?.offerType?.uuid
          ? { value: _initialValues?.offerType?.uuid }
          : null,
        customerType: _initialValues?.customerType?.uuid
          ? { value: _initialValues?.customerType?.uuid }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="OfferForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <OfferCustomerPotenitalFormStepOne {...formProps} {...props} />
              <OfferCustomerPotenitalFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default OfferCustomerPotenitalForm;
